import React, { useState } from 'react'
import { Button, Col, Modal } from 'react-bootstrap'
import { isMobile } from 'helpers'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { completeTrip } from '../actions'
import FormRadio from '../components/FormRadio'
import FormInputDatepicker from './FormInputDatepicker'

const isMobileBrowser = isMobile()

const CompleteTripModal = ({
  show,
  onHide,
  completeTrip,
  bookingId = null,
  supplierId = null,
  isPartner = false,
  number,
  afterAction = () => {},
  noShow = false,
  noShowNote = '',
  isVipService = false,
  isArrival = false,
}) => {
  // console.log('isVipService', isVipService)
  const [additionalCharges, setAdditionalCharges] = useState(false)
  const [isCommentEmpty, setIsCommentEmpty] = useState(false)
  const [onBoardTime, setOnBoardTime] = useState('')
  const [isTimeEmpty, setIsTimeEmpty] = useState(false)

  const onChangeRadio = async option => {
    setAdditionalCharges(option)
    setIsCommentEmpty(false)
  }
  const onClose = () => {
    onHide()
  }
  const onConfirmation = () => {
    console.log('complete booking')
    onCompleteTrip()
  }

  const onCompleteTrip = async () => {
    try {
      if (bookingId) {
        let details = ''
        if (additionalCharges) {
          details = document.getElementById('details').innerText.trim()

          if (!details) {
            setIsCommentEmpty(true)
            return
          } else {
            setIsCommentEmpty(false)
          }

          if (!onBoardTime && !isVipService) {
            setIsTimeEmpty(true)
            return
          } else {
            setIsTimeEmpty(false)
          }
        }

        const info = {
          additionalCharges,
          details,
          onBoardTime,
          isPartner,
          noShow,
          ...(isVipService ? { isVipService } : { isVipService }),
          ...(isArrival ? { isArrival: true } : { isArrival }),
          ...(noShow && noShowNote?.trim() ? { noShowNote } : {}),
        }

        await completeTrip(info, bookingId, supplierId)
        afterAction()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      size='lg'
      show={show}
      onHide={onClose}
      className='decline-offer-booking-modal modal-90w'
      dialogClassName={
        isMobileBrowser ? 'modal-90w decline-offer' : 'modal-90w '
      }
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header>
        <Modal.Title id='example-modal-sizes-title-lg' className='modal-title'>
          {isMobileBrowser && (
            <div className='driver-booking-container-header-booking'>
              <img
                className='driver-back-icon mx-50%'
                src='/images/icon-back.png'
                onClick={() => {
                  onHide()
                }}
                alt=''
              />
              <span style={{ paddingTop: '0.2em' }}>Booking #{number}</span>
              <span></span>
            </div>
          )}
          {!isMobileBrowser && (
            <h1 className='title'>Any additional charges?</h1>
          )}
          <div className='close-btn-wrap'>
            <img
              src={`${
                isMobileBrowser
                  ? '/images/icons/close-icon-black.png'
                  : '/images/icons/modal-close-icon.svg'
              }`}
              alt=''
              height={12}
              width={12}
              style={
                isMobileBrowser
                  ? { marginRight: '12px', marginTop: '10px' }
                  : {}
              }
              onClick={onClose}
            />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isMobileBrowser && <h1 className='title'>Any additional charges?</h1>}
        <p className='modal-description'>
          {!noShow
            ? `Select “Yes” if extra charges, like wait time, stops, or service
          extensions, were incurred.`
            : `Select “Yes” if an extra charge, like wait time, was incurred.`}
        </p>
        <p
          className='modal-description'
          style={
            isMobileBrowser
              ? { marginBottom: '1rem' }
              : { marginBottom: '2rem' }
          }
        >
          Submit the report within 24 hours{!noShow ? ' of drop-off' : ''}. Late
          submissions will result in the booking being marked as completed
          without extra charges.
        </p>
        <div className='modal-options'>
          <FormRadio
            name='no'
            id='no'
            label='No'
            labelClass='options'
            handleChange={() => onChangeRadio(false)}
            checked={!additionalCharges}
          />
          <FormRadio
            name='yes'
            id='yes'
            label='Yes'
            labelClass='options'
            handleChange={() => onChangeRadio(true)}
            checked={additionalCharges}
          />
        </div>
        {additionalCharges ? (
          <div style={{ marginTop: '36px' }}>
            <label>PROVIDE DETAILS*</label>
            <span
              id='details'
              className={`form-group ${
                isVipService
                  ? 'notes-expandable-add-charges-vip'
                  : 'notes-expandable-add-charges'
              }`}
              as='textarea'
              contentEditable='plaintext-only'
              style={
                isMobileBrowser
                  ? {
                      minHeight: '200px',
                      padding: '0.75rem 0.75rem',
                      fontSize: '14px',
                    }
                  : {
                      marginBottom: 0,
                      padding: '0.75rem 0.75rem',
                      fontSize: '14px',
                    }
              }
              onInput={e => {
                const element = e.target
                element.setAttribute(
                  'data-placeholder-active',
                  element.textContent.trim() === '' ? 'true' : 'false'
                )
              }}
              data-placeholder-active='true'
            ></span>
            {isCommentEmpty && (
              <span className='mismatch-text mt-1 mb-1'>
                Please provide additional details.
              </span>
            )}

            {isVipService ? (
              <></>
            ) : (
              //prettier-ignore
              <Col
              className='custom-white-background pl-0 pr-0'
              md={6}
              style={{ marginTop: '16px' }}
            >
              <FormInputDatepicker
                field={{
                  value: onBoardTime,
                  onChange: value => setOnBoardTime(value),
                  name: 'onBoardTime',
                  placeholder: '12:45',
                }}
                label='Passenger on board time*'
                isTimePicker={true}
                removeMargin={true}
                hasError={isTimeEmpty}
                className={'hide-shadow white-no-shadow-field-input'}
              />
              {isTimeEmpty && (
                <span className='mismatch-text-2 mt-1'>
                  Please select a time.
                </span>
              )}
            </Col>
            )}
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        {!isMobileBrowser ? (
          <Button
            className='select-btn select-vehicle partner-btn-desktop'
            variant='brown'
            onClick={onConfirmation}
            style={{ margin: 0 }}
          >
            Submit
          </Button>
        ) : (
          <div className='driver-booking-cta-footer-assign'>
            <Button
              className='select-btn select-vehicle'
              style={{
                width: '100%',
                marginBottom: '15px',
                fontWeight: '900',
                fontSize: '16px',
                textShadow: '0.25px 0 #ffffff',
              }}
              variant='brown'
              onClick={onConfirmation}
            >
              Submit
            </Button>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  )
}
export default withRouter(
  connect(null, {
    completeTrip,
  })(CompleteTripModal)
)
